import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { UserDataProvider } from './contexts/UserDataContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { createClientProvider } from './contexts/ClientContexts';
import { addBackendPrefix } from './utils/backendPrefix';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
});

const {
  ClientContext : UserContext,
  ClientProvider : UserProvider,
} = createClientProvider(addBackendPrefix('/user'));
export { UserContext };

const basename = process.env.REACT_APP_BASENAME || '';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserDataProvider>
	<UserProvider>
	  <QueryClientProvider client={queryClient}>
	    <Router basename={basename}>
	      <Routes>
		<Route path="/" element={<App />} />
	      </Routes>
	    </Router>
	  </QueryClientProvider>
	</UserProvider>
      </UserDataProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
